<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <help :text="$t('help.group_create')" :title="$t('help.group_create_title')"/>
    <div>
      <GroupSubscriptionsView
        :fields="fields"
      />
    </div>
  </div>
</template>

<script>
  import fields from './teamsCreationFields.js';
  import GroupSubscriptionsView from './GroupSubscriptionsView';

  export default {
    name: 'GroupSubscriptionCreation',
    components: {
      GroupSubscriptionsView
    },
    data () {
      return {
        fields: fields
      }
    },
    computed: {
      resourceKey: {
        get: function () {
          return this.$store.getters['resource/currentResource'].key;
        }
      }
    },
  }
</script>